<template>
	<v-form v-model="inputValid" ref="pickerForm">
		<v-menu ref="dateInput" v-model="pickerShowing" @input="handleMenuChange" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y full-width min-width="290px">
			<template #activator="{on}">
				<v-text-field ref="dateTextField" v-on="on" prepend-icon="date_range" v-model="dateFormatted" clearable :label="label" :rules="rules" readonly :error-messages="dateErrors" />
			</template>
			<v-date-picker v-model="dateModel" :min="min" @input="pickerShowing = false"></v-date-picker>
		</v-menu>
	</v-form>
</template>

<script>
	export default {
		name: 'DateInput',
		props: {
			value: {
				type: String,
				default: null
			},
			label: {
				type: String,
				default: 'Select Date'
			},
			rules: {
				type: Array,
				default: () => []
			},
			min: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				pickerShowing: false,
				inputValid: true
			};
		},
		computed: {
			dateModel: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit('input', val);
				}
			},
			dateFormatted: {
				get() {
					return this.$options.filters.formatDate(this.dateModel);
				},
				set() {
					this.dateModel = null;
					this.pickerShowing = false;
				}
			},
			dateErrors() {
				return [];
			}
		},
		methods: {
			handleMenuChange(val) {
				if (!val) {
					this.$refs.pickerForm.validate();
				}
			}
		},
		watch: {
			inputValid(newVal) {
				this.$emit('onValidation', newVal);
			}
		}
	};
</script>

<style scoped></style>
